import { LoginComponent } from "../app/components/login/login.component";

export const environment = {
  production: false,
  language: "sl",
  wgProfileHost: "https://hee-po26-api.borzen.si",
  wgPlatformHost: "https://hee-po25.borzen.si",

  loginComponent: LoginComponent,
  projIcon: "/assets/project-custom/images/logo.png",
  sidebarIcon: "/assets/project-custom/images/logo.png",
  projectCode: "BORZEN_BH",
  projectName: "",
  locale: 'sl-SI',
  useRouteAndMasterpageCache: true,
  ADLoginEnabled: false,
  dateFormat: 'DD.MM.YYYY',
  navigateAwayPopupEnabled: true,
  useEtag: true,
  newRegistrationLinkDocument: "",
  maxChunkNumber: 40,
  maxFileSizeInMb: 10,
  maxFileSizeInMbInMessenger: 10,
  maxRecordNumberPerPageListing: 30,
  cacheEnabled: false,
  version: '1.1.0',
  showOnlyUserInHeader: true,
  googleClientId: "344277045222-1p1hhb7cfelg4au0dbc4vjgap4cdlfj5.apps.googleusercontent.com",
  useOldSearchViewFeature: false,
  usernameAlwaysToLower: true,
  useInlineSearch: false,
  projectSidebarName:"",
  theme:'light'
};